import { Component, OnInit, AfterViewInit, Input, EventEmitter, OnDestroy } from '@angular/core';
import { RoutingAuthenticationService } from '../../services/routing-authentication';
import { Configuration } from '../../configurations/shared.config';
import { InformationProvider } from '../../providers/information.provider';
import { Subscription } from "rxjs/Subscription";

declare var $: any;

@Component({
    moduleId: module.id,
    selector: '[left-nav-menu]',
    templateUrl: 'left-nav-menu.component.html'
})
export class LeftNavMenu implements OnInit, AfterViewInit, OnDestroy {
    modules = Configuration.modulePrefixes;

    className: string;

    pages = Configuration.pages;

    @Input() tabsClosedEvent: EventEmitter<void>;
    subscription: Subscription;
    showOrderReturnsConfirm: boolean = false;
    currentlyVisit: number = 0;
    get allowedModules() {
        return this.routerAuth.allowedModules;
    }

    get allowedPages() {
        return this.routerAuth.allowedPages;
    }

    constructor(private routerAuth: RoutingAuthenticationService, private informationProvider: InformationProvider) { }

    async ngOnInit() {

        await this.routerAuth.init();

        this.subscription = this.tabsClosedEvent.subscribe(() => {
            $(".nested-list.collapse").removeClass("in");
        });
        if (localStorage.getItem('FMSCurrentUser')) {
            let subId = JSON.parse(localStorage.getItem('FMSCurrentUser')).subId;
            if (subId) {
                this.showOrderReturnsConfirm = subId == Configuration.egyptpostCustomSubscriberId ? true : false;
            }
        }
    }

    ngAfterViewInit() {

        this.informationProvider
            .onCurrentModuleChange
            .subscribe(name => {

                // remove the previous active modules
                $('#MainMenu .selected-module').removeClass('selected-module');

                // get the current module
                let element = $(`#MainMenu #${name}-module`);

                // if it doesn't exist, it might be that the page hasn't loaded yet, so set a 5 second timeout
                if (element.length == 0) {
                    setTimeout(() => this.makeActiveModule(name), 5000);
                } else {
                    this.makeActiveModule(name);
                }

            });
        // let expandedTap = $("#MainMenu .main-item[aria-expanded='true']");
        // console.log(expandedTap);

    }

    // selectedTab(e){
    //     jQuery(".main-item.expanded").collapse();
    //     jQuery(e.srcElement).addClass("expanded");
    // }

    private makeActiveModule(name: string) {
        $(`#MainMenu #${name}-module`).addClass('selected-module');
    }
    visit(tabNumber: number) {
        this.currentlyVisit = tabNumber;
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/leftNavMenu/left-nav-menu.component.ts